<div [ngSwitch]="parceriaId">
    <div *ngSwitchCase="1">
        <app-footer-evo></app-footer-evo>
    </div>
    <div *ngSwitchDefault>
        <app-footer-sped></app-footer-sped>
    </div>
</div>